import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from "@sentry/react";
import { captureConsoleIntegration } from '@sentry/integrations';
import reportWebVitals from './reportWebVitals';
import { env as environment }from "./actions/environment";

const root = ReactDOM.createRoot(document.getElementById('root'));
Sentry.init({
	dsn: environment.sentryDSN,
	integrations: [
		Sentry.browserTracingIntegration(),
		captureConsoleIntegration({
			levels: ['error']
		})
	],

	// We recommend adjusting this value in production, or using tracesSampler
	// for finer control
	tracesSampleRate: 1,
});
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
